import styled from "styled-components";
import colors from "../../../../../css/colors";

interface CheckboxWrapperProps {
  minWidth?: string;
  noMargin?: boolean;
  disabled?: boolean;
  checked?: boolean;
}

export const CheckboxWrapper = styled.div<CheckboxWrapperProps>`
  margin-bottom: ${(props) => (props.noMargin ? 0 : "24px")};
  min-width: ${(props) => (props.minWidth ? props.minWidth : "initial")};

  @media screen and (min-width: 768px) {
    margin-right: ${(props) => (props.noMargin ? 0 : "16px")};
  }

  .ant-checkbox-wrapper {
    &:hover {
      .ant-checkbox-inner {
        border-color: ${colors.YELLOW};
      }
    }
  }

  .ant-checkbox-inner {
    background-color: ${(props) =>
      props.checked ? colors.YELLOW : props.disabled ? colors.GREY_BACKGROUND : "initial"};
    border-color: ${(props) => (props.checked ? colors.YELLOW : colors.GREY_LIGHT)} !important;

    &::after {
      border-color: ${colors.BLACK};
    }
  }

  .ant-checkbox-checked {
    background-color: ${colors.YELLOW};

    &::after {
      border-color: ${colors.YELLOW};
    }
  }

  --antd-wave-shadow-color: ${colors.YELLOW};
`;

interface LabelProps {
  fontWeight?: number;
  color?: string;
}

export const Label = styled.span<LabelProps>`
  font-size: 16px;
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : 500)};
  color: ${(props) => (props.color ? props.color : colors.CHARCOAL)};
`;
